<template>
    <div class="app-layout">
        <header class="bg-white sticky top-0 z-50 shadow-sm">
            <nav class="mx-auto flex max-w-7xl items-center justify-between p-4 lg:px-5">
                <a :href="route('main')" class="flex items-center space-x-3 rtl:space-x-reverse">
                    <span class="sr-only">How2Spanish</span>
                    <img class="h-12 w-auto" src="/Logo.svg" alt="How2Spanish"/>
                </a>

                <div class="flex items-center">
                    <ul :class=" {
                            'nav-menu': true,
                            'nav-menu-open': isMenuOpen
                        }">
                        <li>
                            <Link :href="route('login')" class="block text-base py-2 px-3 text-gray-900 rounded
hover:bg-gray-100  md:hover:text-blue-700
md:dark:hover:text-blue-500 dark:text-white dark:hover:bg-gray-700 dark:hover:text-white
                                  md:dark:hover:bg-transparent dark:border-gray-700">
                            {{ $t("login_page.login") }}
                            </Link>
                        </li>
                        <li>
                            <Link :href="route('register')" class="block text-base py-2 px-3 text-gray-900 rounded
hover:bg-gray-100 md:hover:text-blue-700 md:dark:hover:text-blue-500
dark:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent
                                  dark:border-gray-700">
                            {{ $t("login_page.register") }}
                            </Link>
                        </li>
                    </ul>
                    <button @click="toggleMenu" type="button" class="inline-flex relative items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600" aria-controls="navbar-sticky" aria-expanded="false">
                        <span class="sr-only">Open main menu</span>
                        <svg class="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 14">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 1h15M1 7h15M1 13h15"/>
                        </svg>
                    </button>
                </div>
            </nav>
        </header>
        <main class="main" :class=" { 'is-centered': isCentered }">
            <slot></slot>
        </main>
        <footer class="footer">
            © 2025 {{ $t("footer") }}
        </footer>
    </div>
</template>

<script>
import { Link } from '@inertiajs/vue3';
import Logo from "@/components/Logo.vue";

export default {
    name: 'GuestLayout',
    components: {
        Logo,
        Link,
    },
    props: {
        vocabularyItems: Array,
        isCentered: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isMenuOpen: false,
        };
    },
    methods: {
        toggleMenu() {
            this.isMenuOpen = !this.isMenuOpen;
        },
        isActive(route) {
            return window.location.pathname === route;
        }
    }
};
</script>

<style lang="scss" scoped>
@use "../../sass/mixins" as *;

.app-layout {
    display: grid;
    grid-template-rows: auto 1fr auto;
    height: 100%;
    flex: 1;
    overflow: hidden;
}

.nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1200px;
    margin: 0 auto;
}

.nav-logo a {
    font-size: 24px;
    font-weight: bold;
    text-decoration: none;
    color: #333;
}

.nav-toggle {
    font-size: 24px;
    background: none;
    border: none;
    display: none;
}

.nav-menu {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
}

.nav-menu li {
    margin-left: 20px;
}

.nav-menu a {
    text-decoration: none;
    color: #333;
    font-weight: 500;
}

.main {
    flex-grow: 1;
    padding: 57px 20px 20px;
    max-width: 1200px;
    margin: 0 auto;
    width: 100%;
    height: 100%;
    overflow: auto;

    &.is-centered {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }
}

.footer {
    text-align: center;
    padding: 20px;
    background-color: #f8f9fa;
    border-top: 1px solid #ddd;
}

/* Mobile Styles */
@include mobile {
    .nav-toggle {
        display: block;
    }
    .nav-menu {
        flex-direction: column;
        position: absolute;
        top: 82px;
        left: 0;
        right: 0;
        background-color: #f8f9fa;
        display: none;
    }
    .nav-menu-open {
        display: flex;
    }
    .nav-menu li {
        margin: 10px 0;
    }
    .main {
        padding: 10px;
    }
}

/* Tablet Styles */
@include tablet {
    .nav-menu {
        justify-content: space-around;
    }
    .main {
        padding: 15px;
    }
}
</style>
